import { Component, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { User, Categories } from '../../models/User';
import { RestProvider } from '../../providers/rest/rest';
import { HomePage } from '../home/home';
import { Calender } from '../../models/Calander';
import { DatePipe } from '@angular/common';
import { Gotra } from '../../models/Gotra';
import { Nakshatra } from '../../models/Nakshatra';
import { Veda } from '../../models/Veda';
import { SevaData } from '../../models/SevaData';
import { Seva } from '../../models/Seva';
import { PostLogin, Sevacategorty } from '../../models/PostLogin';
import { detachEmbeddedView } from '@angular/core/src/view';
import { PagesExpenditurePage } from '../pages-expenditure/pages-expenditure';
import { SevaBookingResponse } from '../../models/SevaBookingResponse';




@Component({
  selector: 'page-calander',
  templateUrl: 'calander.html',
})
export class CalanderPage implements OnInit {
  mobile_number: any;
  name: string;
  email: string;
  gotra: string;
  nakshatra: any;
  veda: string;
  user_array: User[] = [];
  Calander_Array: Calender[] = [];
  gotra_array: Gotra[];
  nakshatra_array: Nakshatra[];
  today: any;
  masa: any;
  samvatsara: any;
  paksha: any;
  thithi: any;
  shraddha_thithi: any;
  week_day: any;

  date: any;
  date1: any;
  daysInThisMonth: any;
  daysInLastMonth: any;
  daysInNextMonth: any;
  monthNames: string[];
  weekNames: string[];
  veda_array: Veda[];
  currentMonth: any;
  currentYear: any;
  currentDate: any;
  temp_start_date: Date;
  temp_end_date: any;
  calender_cell_selected: boolean = false;
  show_gotra_array: boolean = false;
  show_nakshatra_array: boolean = false;
  show_veda_array: boolean = false;
  show_user_list: boolean = false;
  month_first_day: any;
  date_to_highlight: any;
  heighlighted_cell_color: string;
  default_seva_data = new Calender;
  full_date: any;
  date_to_retrieve_calendar_data: any;
  repopulate_calendar_data: Calender;
  repopulate_sevas: Seva[] = [];
  local: any;
  user_categories: Sevacategorty[] = [];
  type_of_matha: string = "RM";
  matha_number: number = 1001;
  recieptdata: SevaBookingResponse;


  constructor(public navCtrl: NavController, public navParams: NavParams, private restProvider: RestProvider, private datepipe: DatePipe, private alertController: AlertController) {
    //this.temp_start_date = new Date();
    this.monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
    this.weekNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    this.veda_array = [{"id":1, "veda_name":"RigVeda"}, {"id":2, "veda_name":"YajurVeda"}, {"id":3, "veda_name":"AtharvanaVeda"},{"id":4, "veda_name": "SaamaVeda"}]
    this.temp_start_date = new Date();
    if (localStorage.getItem("seva_categories")) {
      console.log("in constructor seva category condition")
      this.user_categories = JSON.parse(localStorage.getItem("seva_categories"));
      // if(this.user_categories.length == 1 && this.user_categories[0].id == 3)
      console.log("usercategory length", this.user_categories.length)
      if (this.user_categories.length == 2 && (this.user_categories[0].id == 3 || this.user_categories[1].id == 3)) {
        console.log("inside seva category length condition")
        this.temp_start_date = new Date("2019-08-04");
        this.temp_start_date.setFullYear(new Date().getFullYear());
        let x = new Date("2019-08-04");
        x.setFullYear(new Date().getFullYear());
        console.log("date for a aradhane user,x", this.temp_start_date, x);
        this.currentMonth = this.monthNames[x.getMonth()];
      }
    }


    console.log("in cons date", this.temp_start_date)
    this.date_to_retrieve_calendar_data = this.datepipe.transform(this.temp_start_date, 'yyyy-MM-dd');
    this.getCalander(this.date_to_retrieve_calendar_data);
  }
  ionViewCanEnter() {
    console.log("in viewcanenter")
    this.temp_start_date = new Date();
    if (localStorage.getItem("recieptdata")) {
      this.recieptdata = JSON.parse(localStorage.getItem("recieptdata"));
    }
    if (localStorage.getItem("seva_categories")) {
      this.user_categories = JSON.parse(localStorage.getItem("seva_categories"));
      //if(this.user_categories.length == 1 && this.user_categories[0].id == 3)
      if (this.user_categories.length == 2 && (this.user_categories[0].id == 3 || this.user_categories[1].id == 3)) {
        this.temp_start_date = new Date("2019-08-04");
        this.temp_start_date.setFullYear(new Date().getFullYear());
        let x = new Date("2019-08-04");
        x.setFullYear(new Date().getFullYear());
        this.currentMonth = this.monthNames[x.getMonth()];
      }
    }
    //this.temp_start_date = new Date()
    this.date_to_retrieve_calendar_data = this.datepipe.transform(this.temp_start_date, 'yyyy-MM-dd');
    this.getCalander(this.date_to_retrieve_calendar_data);
  }
  ionViewDidEnter() {
    console.log("in  cal viewdidenter")
    //this.temp_start_date = new Date()
    this.temp_start_date = new Date();
    if (localStorage.getItem("seva_categories")) {
      this.user_categories = JSON.parse(localStorage.getItem("seva_categories"));
      //if(this.user_categories.length == 1 && this.user_categories[0].id == 3)
      if (this.user_categories.length == 2 && (this.user_categories[0].id == 3 || this.user_categories[1].id == 3)) {
        this.temp_start_date = new Date("2019-08-04");
        this.temp_start_date.setFullYear(new Date().getFullYear());
        let x = new Date("2019-08-04");
        x.setFullYear(new Date().getFullYear());
        this.currentMonth = this.monthNames[x.getMonth()];
      }
    }

    this.date_to_retrieve_calendar_data = this.datepipe.transform(this.temp_start_date, 'yyyy-MM-dd');
    this.getCalander(this.date_to_retrieve_calendar_data);
  }

  ngOnInit() {
    console.log("in calender init")
    this.monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
    this.weekNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    this.veda_array = [{"id":1, "veda_name":"RigVeda"}, {"id":2, "veda_name":"YajurVeda"}, {"id":3, "veda_name":"AtharvanaVeda"},{"id":4, "veda_name": "SaamaVeda"}]


    this.currentMonth = this.monthNames[new Date().getMonth()];
    //this.user_categories = JSON.parse(  localStorage.getItem("seva_categories"));
    console.log("user categories in calendar page init", this.user_categories, this.currentMonth);
    this.currentYear = new Date().getFullYear();
    this.Calander_Array = [];
    this.gotra_array = [];
    this.nakshatra_array = [];
    //this.temp_start_date = new Date("2018-12-01") //in the form yyyy-dd-MM
    this.temp_start_date = new Date()
    if (localStorage.getItem("seva_categories")) {
      this.user_categories = JSON.parse(localStorage.getItem("seva_categories"));
      //if(this.user_categories.length == 1 && this.user_categories[0].id == 3)
      if (this.user_categories.length == 2 && (this.user_categories[0].id == 3 || this.user_categories[1].id == 3)) {
        this.temp_start_date = new Date("2019-08-04");
        this.temp_start_date.setFullYear(new Date().getFullYear());
        let x = new Date("2019-08-04");
        x.setFullYear(new Date().getFullYear());
        this.currentMonth = this.monthNames[x.getMonth()];
      }
    }

    console.log("current month in calendar init", this.currentMonth);
    this.date_to_highlight = this.datepipe.transform(this.temp_start_date, 'yyyy-MM-dd');
    console.log("this.date_to_highlight", this.date_to_highlight)

    this.date_to_retrieve_calendar_data = this.datepipe.transform(this.temp_start_date, 'yyyy-MM-dd');
    console.log("this.date_to_retrieve_calendar_data", this.date_to_retrieve_calendar_data);
    this.getCalander(this.date_to_retrieve_calendar_data);
    this.GetTotalCells();

    //this.temp_start_date = new Date("15/01/2019");

    //this.date1 = new Date()

    this.getSeva();
    console.log(this.Calander_Array)

    if (this.navParams.get('user')) {
      var repopulate_user_data: User = this.navParams.get('user');


      this.mobile_number = (repopulate_user_data.phone) ? repopulate_user_data.phone : null;
      this.name = (repopulate_user_data.name) ? repopulate_user_data.name : null;
      this.email = (repopulate_user_data.emailid) ? repopulate_user_data.emailid : null;
      this.gotra = (repopulate_user_data.gotra) ? repopulate_user_data.gotra : null;
      this.nakshatra = (repopulate_user_data.nakshatra) ? repopulate_user_data.nakshatra : null;
      this.veda = (repopulate_user_data.veda) ? repopulate_user_data.veda : null;
    }
    this.repopulate_calendar_data = this.navParams.get('calendar_details');
    console.log("this.repopulate_calendar_data on init", this.repopulate_calendar_data)
    this.repopulate_sevas = this.navParams.get('sevas_booked');
    this.local = this.navParams.get('local');
    if (this.navParams.get('user')) {
      let x: PostLogin;
      x = this.navParams.data.user
      console.log("navparams:", this.navParams.data.sevacategory)
      this.user_categories = x.svacategory;
      console.log("user categories from tabs", this.user_categories);
    }


  }
  getSeva() {
    //Calling seva details from the server (seva,gotra,nakshatra)
    this.restProvider.getSevaData()
      .subscribe(
        (result: SevaData) => {
          console.log(result);
          if (result) {
            this.gotra_array = result.gotras;
            //console.log(this.gotra_array)
            this.nakshatra_array = result.nakshatras;
            //console.log(this.nakshatra_array)
          }
        },
        error => {
          console.log(error);
        }
      )
  }
  UMSelected() {
    this.matha_number = 1002;
    this.getCalander(this.date_to_retrieve_calendar_data);
  }
  RMSelected() {
    this.matha_number = 1001;
    this.getCalander(this.date_to_retrieve_calendar_data);
  }
  //Function for getting calander data from the Server
  getCalander(date_to_retrieve_calendar_data) {
    this.date_to_retrieve_calendar_data = date_to_retrieve_calendar_data;
    console.log("date to retrive calenar info from server", this.date_to_retrieve_calendar_data);
    //this.restProvider.getCalanderData(this.monthNames.indexOf(this.currentMonth) + 1).subscribe((result) =>
    this.restProvider.getCalanderData(this.matha_number, this.date_to_retrieve_calendar_data).subscribe((result) => {
      console.log("result found", result);
      if (result) {
        //   var

        // dt = new Date(this.temp_start_date);


        //   while (dt <= this.temp_end_date) {
        //     this.Calander_Array.push(result[dt.getDate()]);
        //     dt.setDate(dt.getDate() + 1);



        //return this.Calander_Array;
        // }

        if (result.length == 0) {
          let alert = this.alertController.create({
            title: 'Alert',
            subTitle: 'Calendar info not available',
            buttons: [
              {
                text: 'Ok',
                handler: () => {
                  console.log('Yes clicked');
                }
              }
            ]
          });
          alert.present();
          return;
        }
        this.Calander_Array = [];

        for (let i = 0; i < result.length; i++) {
          this.Calander_Array = result.filter((item) => { return new Date(item.date).getMonth() == this.monthNames.indexOf(this.currentMonth) })
        }

        //defaulting seva date details
        //default_seva_data = new Calender;
        this.date_to_highlight = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
        if (localStorage.getItem("seva_categories")) {
          this.user_categories = JSON.parse(localStorage.getItem("seva_categories"));
          //if(this.user_categories.length == 1 && this.user_categories[0].id == 3)
          if (this.user_categories.length == 2 && (this.user_categories[0].id == 3 || this.user_categories[1].id == 3)) {
            let d = new Date("2019-08-04");
            d.setFullYear(new Date().getFullYear());
            this.date_to_highlight = this.datepipe.transform(new Date(d), 'yyyy-MM-dd');

          }
        }

        this.default_seva_data = this.Calander_Array.find((item) => { return item.date == this.date_to_highlight })
        if (this.repopulate_calendar_data) {

          console.log("got back cal data")
          this.default_seva_data = this.repopulate_calendar_data;
        }
        console.log(this.default_seva_data)
        if (this.default_seva_data) {
          this.calender_cell_selected = true;
          this.samvatsara = this.default_seva_data.samvatsara;
          this.paksha = this.default_seva_data.paksha;
          this.week_day = this.weekNames[new Date(this.default_seva_data.date).getDay()];
          this.date_to_highlight = this.default_seva_data.date;
          this.date = new Date(this.default_seva_data.date).getDate();
          console.log(this.week_day);
          this.masa = this.default_seva_data.maasa;
          this.thithi = this.default_seva_data.tithi;
          this.shraddha_thithi = this.default_seva_data.shraddatithi;
        }
      }
    },
      error => {
        console.log(error);
      }
    )
    console.log("calender", this.Calander_Array);
  }

  //Function for getting user data using phone number
  SearchWithPhoneNo() {
    if (this.mobile_number == null) {
      return;
    }
    if (this.mobile_number.length < 8 || this.mobile_number.length > 10) {

      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Invalid mobile number',
        enableBackdropDismiss: false,
        buttons: [
          {
            text: 'Ok',
            handler: () => {
              console.log('Yes clicked');
              this.show_user_list = false;
              this.mobile_number = null;
            }
          }
        ]
      });
      alert.present();

      return;

    }
    //Calling method from rest service
    this.restProvider.searchUser(this.mobile_number)
      .subscribe(
        (result) => {
          console.log(result, result.length);
          if (result.length > 0) {
            this.show_user_list = !this.show_user_list;
            this.user_array = result;
            this.mobile_number = result[0].phone;
            //this.name = result[0].name; //All the records will have the same phone number, so set it to the first one.
            // TODO: THe following should be move to the dropdown selection 20180820

            // this.name = result[0].name;
            // this.gotra = result[0].gotra;
            // this.nakshatra = result[0].nakshatra;
          }
          else {
            if (this.mobile_number.length < 8 || this.mobile_number.length > 10) {
              return;
            }
            else {
              let alert = this.alertController.create({
                title: 'Alert',
                subTitle: 'No results found',
                enableBackdropDismiss: false,
                buttons: [
                  {
                    text: 'Ok',
                    handler: () => {
                      console.log('Yes clicked');
                    }
                  }
                ]
              });
              alert.present();
            }

          }
        },
        error => {
          console.log(error);
        }
      )
  }
  ShowExistingUser() {
    this.show_user_list = true;
    console.log("arrow cliked", this.show_user_list)
  }


  //Function for selecting user of entered phone number
  SelectUser(d) {
    console.log("selected user", d);
    this.mobile_number = d.phone;
    this.name = d.name;
    this.gotra = d.gotra;
    this.nakshatra = d.nakshatra;
    this.email = d.emailid;
    this.show_user_list = false;
    switch(d.veda){
      case "Y": this.veda = "YajurVeda";break;
      case "R": this.veda = "RigVeda";break;
      case "S": this.veda = "SaamaVeda";break;
      case "A": this.veda = "AtharvanaVeda";break;
    }
    console.log(this.veda);
  }
  closelist() {
    this.show_user_list = false;
  }

  //Setting name
  SetName() {

    console.log("typing new name")
    this.show_user_list = false;

  }
  onKeyPress(event) {
    if (((event.keyCode >= 65 && event.keyCode <= 90)) || (event.keyCode >= 97 && event.keyCode <= 122) || event.keyCode == 32 || event.keyCode == 46) {
      return true
    }
    else {
      return false
    }
  }
  onphonepress(event) {
    console.log("event.charCode in mobile number", event.charCode)
    if (event.charCode == 13) {
      this.SearchWithPhoneNo();

    }
    if ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode == 13)) {
      return true
    }
    else {
      return false
    }

  }
  onKeyPressGotra(event) {
    if ((event.keyCode >= 65 && event.keyCode <= 90) || (event.keyCode >= 97 && event.keyCode <= 122) || event.keyCode == 32 || event.keyCode == 46) {
      this.show_gotra_array = true;
      return true
    }
    else {
      return false
    }
  }
  onKeyPressNakshatra(event) {
    if ((event.keyCode >= 65 && event.keyCode <= 90) || (event.keyCode >= 97 && event.keyCode <= 122) || event.keyCode == 32 || event.keyCode == 46) {
      this.show_nakshatra_array = true;
      return true
    }
    else {
      return false
    }
  }


  onKeyPressVeda(event) {
    if ((event.keyCode >= 65 && event.keyCode <= 90) || (event.keyCode >= 97 && event.keyCode <= 122) || event.keyCode == 32 || event.keyCode == 46) {
      this.show_veda_array = true;
      return true
    }
    else {
      return false
    }
  }

  //email validation
  validateEmail(email: string) {
    if (email != null && email != ' ') {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(email)) {
        // Invalid Email
        console.log("invalid email")
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Invalid email',
          enableBackdropDismiss: false,
          buttons: [
            {
              text: 'Ok',
              handler: () => {
                console.log('Yes clicked');
                this.email = null;
              }
            }
          ]
        });
        alert.present();
        return;
      }
    }
  }
  //Function for setting the selected gotra
  setgotra(gotra) {
    console.log(gotra);
    this.gotra = gotra;
    this.show_gotra_array = false;
  }


  //Function for setting selected nakshatra
  setnakshatra(nakshatra) {
    console.log("nakshatra selected", nakshatra);
    this.nakshatra = nakshatra;
    this.show_nakshatra_array = false;
  }

  //recognizing whether the user clicks the phone searchbar
  SearchbarPhoneActive() {
    //console.log("inside serchbaractive")
    //console.log(this.mobile_number.length);
    if ((this.mobile_number != "") && ((this.mobile_number.length == 10) || this.mobile_number.length == 8)) {
      //this.show_user_list = true;
    }
    if (this.mobile_number.length > 10) {
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Invalid mobile number',
        enableBackdropDismiss: false,
        buttons: [
          {
            text: 'Ok',
            handler: () => {
              console.log('Yes clicked');
              this.mobile_number = null;
              this.show_user_list = false;
            }
          }
        ]
      });
      alert.present();
      return;
    }
    if ((this.mobile_number.length == 10) || (this.mobile_number.length == 8)) {
      //this.SearchWithPhoneNo()
    }



  }
  //recognizing whether the user clicks the gotra searchbar
  SearchbarGotraActive(event) {
    console.log("inside serchbaractive")
    console.log(this.gotra);
    if (this.gotra.trim().length > 0) {
      this.show_gotra_array = true;
    }
    else {
      this.show_gotra_array = false;
    }


  }

  //recognizing whether the user clicks the nakshatra searchbar
  SearchbarNakshatraActive() {
    // console.log("inside serchbaractive")
    console.log("nakshatra", this.nakshatra.trim().length);
    if (this.nakshatra.trim().length > 0) {
      this.show_nakshatra_array = true;
    }
    else {
      this.show_nakshatra_array = false;
    }


  }
  //Function for blur event gotra
  SearchbarPhoneInactive() {
    // console.log("inside serchbargotrainactive")
    if (this.mobile_number == "") {
      this.show_user_list = false;
    }
    //this.show_gotra_array = false;

  }
  //Function for blur event gotra
  SearchbarGotraInactive() {
    // console.log("inside serchbargotrainactive")
    if (this.gotra == "") {
      this.show_gotra_array = false;
    }
    //this.show_gotra_array = false;

  }
  //Function for blur event nakshatra
  SearchbarNakshatraInactive() {
    // console.log("inside serchbarinactive")
    if (this.nakshatra == "") {
      this.show_nakshatra_array = false;
    }


  }
  checkNakshatra() {
    console.log(this.nakshatra, this.show_nakshatra_array)
    if (this.nakshatra && this.show_nakshatra_array == true) {
      console.log("came inside nakshatra invalid case")

      let x = this.nakshatra_array.find((item) => { return item.nakshatra_name == this.nakshatra })
      console.log(x);
      if (!x) {
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Please select a nakshatra from the existing list',
          enableBackdropDismiss: false,
          buttons: [
            {
              text: 'Ok',
              handler: () => {
                console.log('Yes clicked');
                this.nakshatra = null;
                this.show_nakshatra_array = false;
              }
            }
          ]
        });
        alert.present();
        return;
      }
    }
  }

  SearchbarVedaActive() {
    // console.log("inside serchbaractive")
    console.log("veda", this.veda.trim().length);
    if (this.veda.trim().length > 0) {
      this.show_veda_array = true;
    }
    else {
      this.show_veda_array = false;
    }


  }
  SearchbarVedaInactive() {
    // console.log("inside serchbarinactive")
    if (this.veda == "") {
      this.show_veda_array = false;
    }
  }
  setveda(veda) {
    console.log("Veda selected", veda);
    this.veda = veda;
    this.show_veda_array = false;
  }
  //Function for next button click
  GoToNextPage() {
    if (this.nakshatra) {

      let x = this.nakshatra_array.find((item) => { return item.nakshatra_name.trim() == this.nakshatra.trim() })
      console.log(x);
      if (!x) {
        let alert = this.alertController.create({
          title: 'Alert',
          subTitle: 'Please select a nakshatra from the existing list',
          enableBackdropDismiss: false,
          buttons: [
            {
              text: 'Ok',
              handler: () => {
                console.log('Yes clicked');
                this.nakshatra = null;
                this.show_nakshatra_array = false;
              }
            }
          ]
        });
        alert.present();
        return;
      }
    }
    let user_obj = new User();
    let calender_obj = new Calender;
    user_obj.name = this.name;
    user_obj.phone = this.mobile_number;
    user_obj.emailid = this.email;
    user_obj.gotra = this.gotra;
    user_obj.nakshatra = this.nakshatra;
    user_obj.veda = this.veda;
    calender_obj.maasa = this.masa;
    calender_obj.month = this.currentMonth;
    calender_obj.tithi = this.thithi;
    calender_obj.shraddatithi = this.shraddha_thithi;
    calender_obj.samvatsara = this.samvatsara;
    calender_obj.paksha = this.paksha;
    calender_obj.year = this.currentYear;
    calender_obj.date = this.date_to_highlight;
    calender_obj.week_day = this.week_day;
    console.log("date before passing", this.date_to_highlight)
    console.log(user_obj)
    if ((this.mobile_number == null || this.mobile_number == "") || (this.name == null || this.name == "") || (calender_obj == null)) {
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Please enter mandatory inputs',
        enableBackdropDismiss: false,
        buttons: [
          {
            text: 'Ok',
            handler: () => {
              console.log('Yes clicked');
            }
          }
        ]
      });
      alert.present();
      return;
    }
    if ((this.mobile_number.length != 10) && (this.mobile_number.length != 8)) {
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Invalid Mobile number',
        enableBackdropDismiss: false,
        buttons: [
          {
            text: 'Ok',
            handler: () => {
              console.log('Yes clicked');
              this.mobile_number = null;
            }
          }
        ]
      });
      alert.present();
      return;
    }
    this.navCtrl.push(HomePage, { user: user_obj, calander: calender_obj, sevas: this.repopulate_sevas, local: this.local })
  }

  //Function for clear button click
  ClearAllFields() {
    this.mobile_number = null;
    this.name = null;
    this.gotra = null;
    this.nakshatra = null;
    this.email = null;
    this.show_user_list = false;
    if (this.default_seva_data) {
      this.calender_cell_selected = true;
      this.samvatsara = this.default_seva_data.samvatsara;
      this.paksha = this.default_seva_data.paksha;
      this.week_day = this.weekNames[new Date(this.default_seva_data.date).getDay()];
      this.date_to_highlight = this.default_seva_data.date;
      this.date = new Date(this.default_seva_data.date).getDate();
      console.log(this.week_day);
      this.masa = this.default_seva_data.maasa;
      this.thithi = this.default_seva_data.tithi;
      this.shraddha_thithi = this.default_seva_data.shraddatithi;
    }
    else {
      this.samvatsara = null;
      this.masa = null;
      this.thithi = null;
      this.shraddha_thithi = null;
      this.paksha = null;
      this.date = null;
      this.calender_cell_selected = false;
    }
    this.local = null;
    this.repopulate_calendar_data = null;
    this.repopulate_sevas = null;


  }

  //Calendar Functionalities
  daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
  }

  //function foe calander left-arrow button click
  goToLastMonth(num) {
    console.log("before making any changes", num)

    // //let lastMonth = this.monthNames[new Date().getMonth() - 1];

    // console.log(lastMonth)
    let index = this.monthNames.indexOf(num);
    console.log("index", index)
    switch (num) {
      case 'JAN': this.currentMonth = "DEC";
        this.currentYear = this.currentYear - 1;
        break;
      case 'FEB': this.currentMonth = "JAN";
        break;
      case 'MAR': this.currentMonth = "FEB";
        break;
      case 'APR': this.currentMonth = "MAR";
        break;
      case 'MAY': this.currentMonth = "APR";
        break;
      case 'JUN': this.currentMonth = "MAY";
        break;
      case 'JUL': this.currentMonth = "JUN";
        break;
      case 'AUG': this.currentMonth = "JUL";
        break;
      case 'SEP': this.currentMonth = "AUG";
        break;
      case 'OCT': this.currentMonth = "SEP";
        break;
      case 'NOV': this.currentMonth = "OCT";
        break;
      case 'DEC': this.currentMonth = "NOV";
        break;
      default:
        break;

    }
    console.log(this.currentMonth);
    this.temp_start_date = new Date(this.temp_start_date.getFullYear(), this.temp_start_date.getMonth(), 0);
    this.date_to_retrieve_calendar_data = this.datepipe.transform(this.temp_start_date, 'yyyy-MM-dd')
    this.Calander_Array = [];
    console.log("date for calendar in previous month function", this.date_to_retrieve_calendar_data);
    this.getCalander(this.date_to_retrieve_calendar_data);
    this.samvatsara = null;
    this.masa = null;
    this.thithi = null;
    this.shraddha_thithi = null;
    this.paksha = null;
    this.date = null;
    this.calender_cell_selected = false;

    this.GetTotalCells();

  }

  //Function for calender righr arrow button click
  goToNextMonth(num) {
    //this.currentMonth = this.monthNames[this.currentMonth + 1];
    //console.log(this.currentMonth)
    let index = this.monthNames.indexOf(num);
    console.log("index", index)
    console.log("month befre making any changes", num)
    switch (num) {
      case 'JAN': this.currentMonth = "FEB";
        break;
      case 'FEB': this.currentMonth = "MAR";
        break;
      case 'MAR': this.currentMonth = "APR";
        break;
      case 'APR': this.currentMonth = "MAY";
        break;
      case 'MAY': this.currentMonth = "JUN";
        break;
      case 'JUN': this.currentMonth = "JUL";
        break;
      case 'JUL': this.currentMonth = "AUG";
        break;
      case 'AUG': this.currentMonth = "SEP";
        break;
      case 'SEP': this.currentMonth = "OCT";
        break;
      case 'OCT': this.currentMonth = "NOV";
        break;
      case 'NOV': this.currentMonth = "DEC";
        break;
      case 'DEC': this.currentMonth = "JAN";
        this.currentYear = this.currentYear + 1;
        break;
      default:
        break;

    }
    console.log(this.currentMonth);

    this.temp_start_date = new Date(this.temp_start_date.getFullYear(), this.temp_start_date.getMonth() + 2, 0);
    this.date_to_retrieve_calendar_data = this.datepipe.transform(this.temp_start_date, 'yyyy-MM-dd')
    console.log("date for calendar in next month function", this.date_to_retrieve_calendar_data);
    this.Calander_Array = [];
    this.getCalander(this.date_to_retrieve_calendar_data);
    this.samvatsara = null;
    this.masa = null;
    this.thithi = null;
    this.shraddha_thithi = null;
    this.paksha = null;
    this.date = null;
    this.calender_cell_selected = false;
    this.GetTotalCells();


  }

  //Function for calender cell selection
  getCurrentDateDetails(data: Calender) {
    console.log("data passed", data);
    if (this.type_of_matha == "UM") {
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Please select Raghavendraswamy matha calendar for seva booking',
        enableBackdropDismiss: false,
        buttons: [
          {
            text: 'Ok',
            handler: () => {
              console.log('Yes clicked');
            }
          }
        ]
      });
      alert.present();
      return;
    }
    console.log(this.currentMonth)
    // if(( (new Date(data.date).getDate()) < (new Date().getDate()) && (this.monthNames.indexOf(this.currentMonth) < new Date().getMonth())) || ((this.monthNames.indexOf(this.currentMonth) == new Date().getMonth()) || (this.monthNames.indexOf(this.currentMonth) < new Date().getMonth()) || (this.currentYear < new Date().getFullYear())))
    // if((new Date(data.date).getDate() < new Date().getDate() && this.monthNames.indexOf(this.currentMonth) == new Date().getMonth()) || (this.monthNames.indexOf(this.currentMonth) < new Date().getMonth()) || (this.currentYear < new Date().getFullYear()))
    // {

    // if(new Date(data.date).getFullYear()<= new Date().getFullYear()  )
    //   {
    //     console.log("came inside year condition",this.currentYear,new Date(data.date).getFullYear())
    //       if(new Date(data.date).getMonth() <= new Date().getMonth())
    //       {
    //         console.log("came inside month condition",new Date().getMonth(),new Date(data.date).getMonth())
    //         if((new Date(data.date).getMonth() <= new Date().getMonth() && new Date(data.date).getDate() <= new Date().getDate()) || (new Date(data.date).getMonth() < new Date().getMonth() && new Date(data.date).getDate() >= new Date().getDate()))
    //         {
    //           console.log("came inside date condition",new Date().getDate(),new Date(data.date).getDate())
    //           let alert = this.alertController.create({
    //             title: 'Alert',
    //             subTitle: 'Invalid Date',
    //             buttons: [
    //               {
    //                 text: 'Ok',
    //                 handler: () => {
    //                   console.log('Yes clicked');
    //                 }
    //               }
    //             ]
    //           });
    //           alert.present();
    //           return;
    //         }
    //       }
    //   }


    //fix
    //if(this.user_categories.length == 1 && this.user_categories[0].id == 3)
    // if (this.user_categories.length == 2 && (this.user_categories[0].id == 3 || this.user_categories[1].id == 3)) {
    //   console.log("came inside aradhane special condition")
    //   if ((new Date(data.date).getFullYear() < new Date().getFullYear()) || (new Date(data.date).getFullYear() > new Date().getFullYear())) {
    //     console.log("came inside aradahne special  year condition", this.currentYear, new Date(data.date).getFullYear())
    //     let alert = this.alertController.create({
    //       title: 'Alert',
    //       subTitle: 'Invalid Date',
    //       enableBackdropDismiss: false,
    //       buttons: [
    //         {
    //           text: 'Ok',
    //           handler: () => {
    //             console.log('Yes clicked');
    //           }
    //         }
    //       ]
    //     });
    //     alert.present();
    //     return;
    //   }

    //   else if (new Date(data.date).getFullYear() == new Date().getFullYear() && new Date(data.date).getMonth() < 7) {
    //     console.log("came inside aradhane special month condition", new Date().getMonth(), new Date(data.date).getMonth())
    //     let alert = this.alertController.create({
    //       title: 'Alert',
    //       subTitle: 'Invalid Date',
    //       enableBackdropDismiss: false,
    //       buttons: [
    //         {
    //           text: 'Ok',
    //           handler: () => {
    //             console.log('Yes clicked');
    //           }
    //         }
    //       ]
    //     });
    //     alert.present();
    //     return;
    //   }

    //   else if ((new Date(data.date).getFullYear() == new Date().getFullYear() && ((new Date(data.date).getMonth() < 7) || (new Date(data.date).getMonth() > 7))) || ((new Date(data.date).getFullYear() == new Date().getFullYear()) && new Date(data.date).getMonth() == 7) && ((new Date(data.date).getDate() < 4) || (new Date(data.date).getDate() > 19))) {
    //     console.log("came inside aradhane special date condition", new Date().getDate(), new Date(data.date).getDate())
    //     let alert = this.alertController.create({
    //       title: 'Alert',
    //       subTitle: 'Invalid Date',
    //       enableBackdropDismiss: false,
    //       buttons: [
    //         {
    //           text: 'Ok',
    //           handler: () => {
    //             console.log('Yes clicked');
    //           }
    //         }
    //       ]
    //     });
    //     alert.present();
    //     return;
    //   }

    // } //end of user_cat condition


    if (new Date(data.date).getFullYear() < new Date().getFullYear()) {
      console.log("came inside year condition", this.currentYear, new Date(data.date).getFullYear())
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Invalid Date',
        enableBackdropDismiss: false,
        buttons: [
          {
            text: 'Ok',
            handler: () => {
              console.log('Yes clicked');
            }
          }
        ]
      });
      alert.present();
      return;
    }

    else if (new Date(data.date).getFullYear() == new Date().getFullYear() && new Date(data.date).getMonth() < new Date().getMonth()) {
      console.log("came inside month condition", new Date().getMonth(), new Date(data.date).getMonth())
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Invalid Date',
        enableBackdropDismiss: false,
        buttons: [
          {
            text: 'Ok',
            handler: () => {
              console.log('Yes clicked');
            }
          }
        ]
      });
      alert.present();
      return;
    }

    else if ((new Date(data.date).getFullYear() == new Date().getFullYear() && new Date(data.date).getMonth() < new Date().getMonth()) && (new Date(data.date).getDate() <= new Date().getDate() || new Date(data.date).getDate() >= new Date().getDate()) || (new Date(data.date).getFullYear() == new Date().getFullYear() && new Date(data.date).getMonth() == new Date().getMonth()) && (new Date(data.date).getDate() < new Date().getDate())) {
      console.log("came inside date condition", new Date().getDate(), new Date(data.date).getDate())
      let alert = this.alertController.create({
        title: 'Alert',
        subTitle: 'Invalid Date',
        enableBackdropDismiss: false,
        buttons: [
          {
            text: 'Ok',
            handler: () => {
              console.log('Yes clicked');
            }
          }
        ]
      });
      alert.present();
      return;
    }



    //   let alert = this.alertController.create({
    //     title: 'Alert',
    //     subTitle: 'Invalid Date',
    //     buttons: [
    //       {
    //         text: 'Ok',
    //         handler: () => {
    //           console.log('Yes clicked');
    //         }
    //       }
    //     ]
    //   });
    //   alert.present();
    //   return;
    // }


    this.calender_cell_selected = true;
    this.samvatsara = data.samvatsara;
    this.paksha = data.paksha;
    this.week_day = this.weekNames[new Date(data.date).getDay()];
    this.date_to_highlight = data.date;
    this.date = new Date(data.date).getDate();
    //this.date = data.date;
    console.log(this.week_day);
    this.masa = data.maasa;
    this.thithi = data.tithi;
    this.shraddha_thithi = data.shraddatithi;
  }

  //Function for setting calender cells
  GetTotalCells() {
    this.daysInThisMonth = new Array();
    this.daysInLastMonth = new Array();
    this.daysInNextMonth = new Array();
    console.log("temp start date in gettotal cells method", this.temp_start_date)
    this.temp_start_date = new Date(this.datepipe.transform(this.temp_start_date, 'yyyy-MM-dd'));
    var firstDayThisMonth = new Date(this.temp_start_date.getFullYear(), this.temp_start_date.getMonth(), 1).getDay();
    console.log("firstDayThisMonth", firstDayThisMonth)

    var prevNumOfDays = new Date(this.temp_start_date.getFullYear(), this.temp_start_date.getMonth(), 0).getDate();
    console.log("prevNumOfDays", prevNumOfDays)

    for (var i = prevNumOfDays - (firstDayThisMonth - 1); i <= prevNumOfDays; i++) {
      this.daysInLastMonth.push(i);
    }
    console.log("this.daysInLastMonth", this.daysInLastMonth)

    var thisNumOfDays = new Date(this.temp_start_date.getFullYear(), this.temp_start_date.getMonth() + 1, 0).getDate();
    console.log("thisNumOfDays", thisNumOfDays)

    for (var i = 0; i < thisNumOfDays; i++) {
      this.daysInThisMonth.push(i + 1);
    }

    var lastDayThisMonth = new Date(this.temp_start_date.getFullYear(), this.temp_start_date.getMonth() + 1, 0).getDay();
    console.log(lastDayThisMonth)
    var nextNumOfDays = new Date(this.temp_start_date.getFullYear(), this.temp_start_date.getMonth() + 2, 0).getDate();
    console.log("nextNumOfDays", nextNumOfDays)
    for (var i = 0; i < (6 - lastDayThisMonth); i++) {
      this.daysInNextMonth.push(i + 1);
    }
    var totalDays = this.daysInLastMonth.length + this.daysInThisMonth.length + this.daysInNextMonth.length;
    if (totalDays < 36) {
      for (var i = (7 - lastDayThisMonth); i < ((7 - lastDayThisMonth) + 7); i++) {
        this.daysInNextMonth.push(i);
      }
      console.log("daysInNextMonth", this.daysInNextMonth)
    }
  }

  expenditurePgae() {
    this.navCtrl.push(PagesExpenditurePage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/calander/calander.ts